.field-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border: 1px solid var(--off-white-dk);
    border-radius: 4px;
    background: var(--white);
    cursor: pointer;
    transition: all 0.15s ease;
    font-size: var(--font-small);
    color: var(--grey-dk);
}

.field-toggle:hover {
    border-color: var(--blue);
}

.field-toggle--selected {
    border-color: var(--blue);
}
